import { ProgressIndicator } from "@9amhealth/shared";
import { useBlocNext } from "@blac/react";
import type { FC } from "react";
import React from "react";
import type FunnelKey from "src/constants/funnelKey";
import translate from "src/lib/translate";
import type { SignupCustomStep } from "../SignupCustom.types";
import { SignupCustomStepType } from "../SignupCustom.types";
import {
  GenericTemplateFunnelLocalStorageKeys,
  lsKey
} from "../campaigns/FactorySignupCustomCampaign";
import { StorageController } from "src/state/StorageBloc/StorageBloc";
import SignupCustomBloc from "../state/SignupCustomBloc";

const SignupCustomStepAction: FC<{
  step: SignupCustomStep;
  onStepCompleted: (step: SignupCustomStep) => Promise<boolean> | boolean;
  funnelKey?: string;
}> = React.memo(({ step, onStepCompleted, funnelKey }) => {
  const [, { showSaving }] = useBlocNext(SignupCustomBloc);
  const stepTypeMatch = step.type === SignupCustomStepType.Action;

  React.useEffect(() => {
    if (!stepTypeMatch) return;

    showSaving({
      text: translate("savingIndicator.info", { context: "preparingNextStep" })
    });

    void step.action().finally(() => {
      const lsk = lsKey(
        (funnelKey ?? "") as FunnelKey,
        `${GenericTemplateFunnelLocalStorageKeys.CustomStepActionPrefix}evaluate-data`
      );
      StorageController.setItem(lsk, "true");
      void onStepCompleted(step);
    });
  }, [stepTypeMatch]);

  return stepTypeMatch ? <ProgressIndicator indeterminate /> : <></>;
});

export default SignupCustomStepAction;
